import {Button, Col, Form, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {getPropertyList, sendFileData, sendInCommFileData} from "../actions/backOfficeAction";
import {useDispatch, useSelector} from "react-redux";

const UploadInCommFileForm = ({ idle }) => {

  //const [propertySelected, setPropertySelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();

  const submitFileHandler = (e) => {
    e.preventDefault();

    // Only submit the file if a file has actually been chosen
    if (selectedFile != null) {

      // Submit the file
      dispatch(sendInCommFileData(selectedFile, e));

      // Clear the file selection
      setSelectedFile(null);
      document.getElementById("InCommFormControlFile").value = "";

    } else {
      setErrorMessage("You must select a file to upload");
    }
  };

  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setErrorMessage("");
  };

  return (
    <div className="admin-screen-divider-div">
      <h3>InComm Shop File Upload</h3>
      <Form
        name="fileLoadForm"
        encType="multipart/form-data"
        action=""
        onSubmit={submitFileHandler}
        className="gcotg-form"
      >
        <Row>
          <Col>
            <div className="form-group backoffice-fileload-form-group">
              <label htmlFor={"file"} className="backoffice-form-label">1. Select the file to upload</label>
              <input
                type="file"
                name="file"
                className="form-control-file gcotg-form-element"
                id="InCommFormControlFile"
                onChange={(e) => onFileChange(e)}
              ></input>
            </div>
          </Col>
          <Col className="upload-button-column">
            <label htmlFor="Property name for the file" className="backoffice-form-label">
              2. Click the button to upload
            </label>
            <Button
              variant="primary"
              type="submit"
              className="upload-button gcotg-button"
            >
              Upload
            </Button>
          </Col>
          <div className="backoffice-error-messages">
            {errorMessage.length > 0 ? (
              <div className="alert alert-danger" role="alert">
                <p>
                  {errorMessage}
                </p>
              </div>
            ) : ""}
          </div>
        </Row>
      </Form>
    </div>
  );
};

export default UploadInCommFileForm;